import {downloadSampleImportVatTu} from "../phan-he-nhap-kho/services/services";
import {toast} from "react-toastify";
import {Button} from "react-bootstrap";
import {useContext} from "react";
import {AppContext} from "../appContext/AppContext";

const BtnDownloadSampleImport = () => {
  const {setIsLoading} = useContext(AppContext);

  const handleDownloadSampleImport = async () => {
    try {
      setIsLoading(true);
      const response = await downloadSampleImportVatTu();
      const blob = new Blob([response.data], {type: "application/xlsx"});
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = `Sample Import VatTu.xlsx`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    } catch (error) {
      toast.error("Có lỗi xảy ra, vui lòng thử lại");
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };
  return (
    <Button className="btn-fill spaces min-w-90px btn btn-primary ml-4" onClick={handleDownloadSampleImport}>
      Tải mẫu nhập Excel
    </Button>
  );
};

export default BtnDownloadSampleImport
